export const PAGINATION_LIMIT = 25

export const NYC_ORGANIZATION_ID = '6966036a-12d4-4a57-a2ad-c119d797edd1'
export const DRIVERS_UNION_ID = '1f0636ef-588f-4dbd-ab55-114750af7dc2'
export const UNION360 = '6b007544-3832-4a1f-a47a-e07535e3b2ec'

export const ALL_ORGANIZATION_NAMES = [
  'wbf',
  'bcf-new-york',
  'idg-illinois',
  'drivers-union',
  'demonstration-org',
  'drivers-demand-justice',
  'union360',
  'idg-connecticut',
  'idg-florida',
  'idg-state-is-not-listed',
  'idg-machinists-union',
  'idg-new-jersey',
  'benestream',
  'idg-new-york',
]

export const POLICIES = {
  IsAllTaskEnabled: 'is_enable_all_tasks',
  isShowMetlifeIdEnabled: 'is_show_metlifeId_enabled',
  IsWashingtonStateBuildFullDriverEarningsReportEnabled:
    'is_washington_state_build_full_driver_earnings_report_enabled',
  IsWastateViewEnabled: 'is_wastate_view_enabled',
  IsWastateOpenFormEnabled: 'is_wastate_open_form_enabled',
  IsWastateUpdateEnabled: 'is_wastate_update_enabled',
  IsEnableViewFormSubmission: 'is_enable_view_form_submission',
  IsGetForms: 'is_get_forms',
  IsEnableViewFormSubmissionsTab: 'is_enable_view_form_submissions_tab',
  IsOpenFormSubmissionEnabled: 'is_open_form_submission_enabled',
  isGetEscalationsEnabled: 'is_get_escalations_enabled',
  isCreateEscalationEnabled: 'is_create_escalation_enabled',
  isUpdateEscalationEnabled: 'is_update_escalation_enabled',
  isEscalationsTableEnabled: 'is_escalations_table_enabled',
  isDeleteEscalationEnabled: 'is_delete_escalation_by_id_enabled',
  isRemoveFormAttachmentsEnabled: 'is_delete_escalation_by_id_enabled',

  isGeTaskByPersonIdEnabled: 'is_get_task_by_person_id_enabled',
  isGetTasksEnabled: 'is_get_tasks_enabled',
  isCreateTaskEnabled: 'is_create_task_enabled',
  isMergePersonsEnabled: 'is_merge_persons_enabled',
  isCreateMultipleTasksEnabled: 'is_create_multiple_task_enabled',
  isUpdateTaskEnabled: 'is_update_task_enabled',

  isGetOfficeVisitEnabled: 'is_get_office_visits_enabled',
  isEnrollmentCheckerVendorsEnabled: 'is_enrollment_checker_vendors_enabled',

  isGetChatMessagesEnabled: 'is_get_chat_messages_enabled',
  isCreateChatMessageEnabled: 'is_create_chat_message_enabled',
}

export const LANGUAGES_FOR_LOCATIONS = [
  { label: 'Arabic', value: 'ar' },
  { label: 'Armenian', value: 'hy' },
  { label: 'Cantonese', value: 'yue' },
  { label: 'Chinese', value: 'zh' },
  { label: 'Creole', value: 'ht' },
  { label: 'Czech', value: 'cs' },
  { label: 'Dutch', value: 'nl' },
  { label: 'Farsi', value: 'fa' },
  { label: 'Filipino', value: 'fil' },
  { label: 'Finnish', value: 'fi' },
  { label: 'French', value: 'fr' },
  { label: 'German', value: 'de' },
  { label: 'Greek', value: 'el' },
  { label: 'Gujarati', value: 'gu' },
  { label: 'Hebrew', value: 'he' },
  { label: 'Hindi', value: 'hi' },
  { label: 'Ilocano', value: 'ilo' },
  { label: 'Indonesian', value: 'id' },
  { label: 'Italian', value: 'it' },
  { label: 'Japanese', value: 'ja' },
  { label: 'Korean', value: 'ko' },
  { label: 'Kurdish', value: 'ku' },
  { label: 'Mandarin', value: 'zh-CN' },
  { label: 'Marathi', value: 'mr' },
  { label: 'Persian', value: 'fa' },
  { label: 'Polish', value: 'pl' },
  { label: 'Portuguese', value: 'pt' },
  { label: 'Romanian', value: 'ro' },
  { label: 'Russian', value: 'ru' },
  { label: 'Spanish', value: 'es' },
  { label: 'Swedish', value: 'sv' },
  { label: 'Tagalog', value: 'tl' },
  { label: 'Thai', value: 'th' },
  { label: 'Turkish', value: 'tr' },
  { label: 'Ukrainian', value: 'uk' },
  { label: 'Urdu', value: 'ur' },
  { label: 'Vietnamese', value: 'vi' },
  { label: 'Yiddish', value: 'yi' },
]
